import { SiEthereum, SiBinance } from "react-icons/si";
import { appConfig } from "../../../config";

export type RpcURL = {
  http: string | undefined,
  webSocket?: string,
}

export type ChainInfo = {
  chainId: number,
  longName: string,
  name: string,
  rpc: RpcURL,
  blockexplorer: string,
  iconLinear: string,
  nativeCurrency: {
    name: string,
    symbol: string,
    decimals: number,
  },
  existing: boolean,
  icon?: React.ElementType,
}

export const CHAINS: Record<number, ChainInfo> = {
  1: {
    chainId: 1,
    longName: 'Ethereum Mainnet',
    name: 'Ethereum',
    rpc: {
      http: `https://mainnet.infura.io/v3/${appConfig.infura.key}`,
      webSocket: `wss://mainnet.infura.io/ws/v3/${appConfig.infura.key}`
    },
    blockexplorer: 'https://etherscan.io/',
    iconLinear: 'ethereum0_linear',
    nativeCurrency: {
      name: 'ETH',
      symbol: 'ETH',
      decimals: 18,
    },
    existing: true,
    icon: SiEthereum,
  },
  11155111: {
    chainId: 11155111,
    longName: 'Sepolia Test Network',
    name: 'Sepolia',
    rpc: {
      http: `https://eth-sepolia.g.alchemy.com/v2/${appConfig.alchemy.key}`,
      webSocket: `wss://eth-sepolia.g.alchemy.com/v2/${appConfig.alchemy.key}`,
    },
    blockexplorer: 'https://sepolia.etherscan.io/',
    iconLinear: 'ethereum0_linear',
    nativeCurrency: {
      name: 'SepoliaETH',
      symbol: 'SepoliaETH',
      decimals: 18,
    },
    existing: true,
    icon: SiEthereum,
  },
  56: {
    chainId: 56,
    longName: 'Binance Smart Chain',
    name: 'Binance',
    rpc: {
      http: process.env.REACT_APP_BINANCE_NODE_MAINNET ?? "https://bsc-dataseed1.binance.org/"
    },
    blockexplorer: 'https://bscscan.com',
    iconLinear: 'binance0_linear',
    nativeCurrency: {
      name: 'BNB',
      symbol: 'BNB',
      decimals: 18,
    },
    existing: false,
    icon: SiBinance,
  },
  97: {
    chainId: 97,
    longName: 'Binance Smart Chain Testnet',
    name: 'BSC Testnet',
    rpc: {
      http: process.env.REACT_APP_BINANCE_NODE_TESTNET ?? "https://bsc-testnet.public.blastapi.io/"
    },
    blockexplorer: 'https://testnet.bscscan.com',
    iconLinear: 'binance0_linear',
    nativeCurrency: {
      name: 'TBNB',
      symbol: 'TBNB',
      decimals: 18,
    },
    existing: false,
    icon: SiBinance,
  },
  137: {
    chainId: 137,
    longName: 'Polygon Mainnet',
    name: 'Polygon',
    rpc: {
      http: 'https://rpc-mainnet.maticvigil.com/'
    },
    blockexplorer: 'https://polygonscan.com',
    iconLinear: 'binance0_linear',
    nativeCurrency: {
      name: 'MATIC',
      symbol: 'MATIC',
      decimals: 18,
    },
    existing: false,
  },
  80001: {
    chainId: 80001,
    longName: 'Polygon Testnet',
    name: 'Mumbai',
    rpc: {
      http: 'https://rpc-mumbai.maticvigil.com'
    },
    blockexplorer: 'https://mumbai.polygonscan.com/',
    iconLinear: 'binance0_linear',
    nativeCurrency: {
      name: 'MATIC',
      symbol: 'MATIC',
      decimals: 18,
    },
    existing: false,
  },
  43114: {
    chainId: 43114,
    longName: 'Avax Mainnet',
    name: 'Avax',
    rpc: {
      http:"https://api.avax.network/ext/bc/C/rpc"
    },
    blockexplorer: 'https://snowtrace.io/',
    iconLinear: 'binance0_linear',
    nativeCurrency: {
      name: 'AVAX',
      symbol: 'AVAX',
      decimals: 18,
    },
    existing: false,
  },
  43113: {
    chainId: 43113,
    longName: 'Avax Testnet',
    name: 'Fuji',
    rpc: {
      http: "https://api.avax-test.network/ext/bc/C/rpc"
    },
    blockexplorer: 'https://testnet.snowtrace.io/',
    iconLinear: 'binance0_linear',
    nativeCurrency: {
      name: 'AVAX',
      symbol: 'AVAX',
      decimals: 18,
    },
    existing: false,
  },
  42161: {
    chainId: 42161,
    longName: 'Arbitrum One',
    name: 'Arbitrum',
    rpc: {
      http: 'https://arb1.arbitrum.io/rpc'
    },
    blockexplorer: 'https://arbiscan.io/',
    iconLinear: 'binance0_linear',
    nativeCurrency: {
      name: 'ETH',
      symbol: 'ETH',
      decimals: 18,
    },
    existing: false,
  },
  421613: {
    chainId: 421613,
    longName: 'Arbitrum Testnet',
    name: 'ArbitrumGoerli',
    rpc: {
      http: 'https://goerli-rollup.arbitrum.io/rpc'
    },
    blockexplorer: 'https://goerli.arbiscan.io',
    iconLinear: 'binance0_linear',
    nativeCurrency: {
      name: 'AGOR',
      symbol: 'AGOR',
      decimals: 18,
    },
    existing: false,
  },
  8453: {
    chainId: 8453,
    longName: 'Base Mainnet',
    name: 'Base',
    rpc: {
    http: 'https://mainnet.base.org'
   },
    blockexplorer: 'https://base.blockscout.com/',
    iconLinear: 'binance0_linear',
    nativeCurrency: {
      name: 'ETH',
      symbol: 'ETH',
      decimals: 18,
    },
    existing: false,
  },
  84532: {
    chainId: 84532,
    longName: 'Base Testnet',
    name: 'Base',
    rpc: {
      http: 'https://sepolia.base.org'
     },
    blockexplorer: 'https://sepolia-explorer.base.org',
    iconLinear: 'binance0_linear',
    nativeCurrency: {
      name: 'ETH',
      symbol: 'ETH',
      decimals: 18,
    },
    existing: false,
  },
  2741: {
    chainId: 2741,
    longName: 'Abstract',
    name: 'Abstract',
    rpc: {
      http: 'https://api.mainnet.abs.xyz'
     },
    blockexplorer: 'https://abscan.org/',
    iconLinear: 'binance0_linear',
    nativeCurrency: {
      name: 'ETH',
      symbol: 'ETH',
      decimals: 18,
    },
    existing: false,
  },
  11124: {
    chainId: 11124,
    longName: 'Abstract Testnet',
    name: 'abstract testnet',
    rpc: {
      http: '	https://api.testnet.abs.xyz'
     },
    blockexplorer: 'https://sepolia.abscan.org/',
    iconLinear: 'binance0_linear',
    nativeCurrency: {
      name: 'ETH',
      symbol: 'ETH',
      decimals: 18,
    },
    existing: false,
  },
  11155420: {
    chainId: 11155420,
    longName: 'OP Sepolia',
    name: 'OP Sepolia',
    rpc: {
      http: 'https://sepolia.optimism.io'
     },
    blockexplorer: 'https://optimism-sepolia.blockscout.com',
    iconLinear: 'binance0_linear',
    nativeCurrency: {
      name: 'ETH',
      symbol: 'ETH',
      decimals: 18,
    },
    existing: false,
  },
   10: {
    chainId: 10,
    longName: 'OP Mainnet',
    name: 'OP Mainnet',
    rpc: {
      http: 'https://mainnet.optimism.io'
     },
    blockexplorer: 'https://optimistic.etherscan.io',
    iconLinear: 'binance0_linear',
    nativeCurrency: {
      name: 'ETH',
      symbol: 'ETH',
      decimals: 18,
    },
    existing: false,
  },
};

export const getSupportedChainIds = (): number[] => {
  const supportedChainIds = appConfig.supportChainIds.default
  const envChains = supportedChainIds.split(',').map((chainId) =>
    Number(chainId),
  );
  return envChains;
};

export const getLockSupportedChainIds = () => {
  const supportedChainIds = appConfig.supportChainIds.gainsLock
  const envChains = supportedChainIds.split(',').map((chainId) => Number(chainId));
  // filters the chainIds by the configured ones.
  return envChains;
}

export const getLockSupportedChainsWithInfo = () => {
  const supportedChainIds = getLockSupportedChainIds();
  const chains: ChainInfo[] = [];
  for (const chainId of supportedChainIds) {
    chains.push(getChainInfo(chainId) as ChainInfo);
  }
  return chains;
}

export const getChainInfo = (chainId: number ) => {
  return CHAINS[chainId];
};

export const getChainName = (chainId: number) => {
  return CHAINS[chainId].name;
}

export const getRpcUrls = () => {
  const rpc: any = {};
  const supportedChainIds = getSupportedChainIds();
  for (const chainId of supportedChainIds) {
    rpc[chainId] = (getChainInfo(chainId) as ChainInfo)?.rpc;
  }
  return rpc;
}

export const getRpcUrl = (chainId: number) => {
  const chainInfo = getChainInfo(chainId);
  if (chainInfo) {
    return chainInfo.rpc;
  }
  return null;
}

export const getRpcUrlHttp = (chainId: number) => {
  const chainInfo = getChainInfo(chainId);
  return chainInfo.rpc.http;
}

export const getExplorerUrl = (chainId: number) => {
  const chainInfo = getChainInfo(chainId);
  if (chainInfo) {
    return chainInfo.blockexplorer
  }
  return null;
}
